import TextFormField from '../../text-form-field';
import { jsx as _jsx } from "react/jsx-runtime";

var TextInput = function TextInput(_ref) {
  var name = _ref.name,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      questionType = _ref.questionType,
      _ref$questionForm = _ref.questionForm,
      control = _ref$questionForm.control,
      errors = _ref$questionForm.formState.errors;
  return /*#__PURE__*/_jsx(TextFormField, {
    control: control,
    name: name,
    required: required,
    errorMessage: "Must be a valid URL",
    link: questionType === 'LinkQuestion',
    multiline: questionType === 'LongAnswerQuestion',
    minRows: questionType === 'LongAnswerQuestion' ? 3 : 1,
    error: errors[name],
    "data-element": "TextFormField",
    "data-component": "TextInput",
    "data-source-file": "text.tsx"
  });
};

export default TextInput;